import { render, staticRenderFns } from "./FgotpwsMyntin.vue?vue&type=template&id=774fcd76&"
import script from "./FgotpwsMyntin.vue?vue&type=script&lang=js&"
export * from "./FgotpwsMyntin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports